import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";
import { PercentBadge } from "@/components/PercentBadge/PercentBadge";
import { useCall } from "@/hooks/useCall/useCall";
import { useGetPlaybookResults } from "@/hooks/useGetPlaybookResults";
import { useFeatureFlags } from "@/providers/FeatureFlagProvider/FeatureFlagProvider";
import { Spinner } from "@aircall/ds";
import { t } from "i18next";
import { PlaybookResultsForm } from "../PlaybookResultsForm/PlaybookResultsForm";

export function SectionPlaybook() {
  const { call } = useCall();
  const callId = call?.id ?? undefined;
  const { playbookResult, loading } = useGetPlaybookResults(callId);
  const { playbookAdherence } = useFeatureFlags();

  if (!callId) {
    return null;
  }

  if (loading) {
    return (
      <div className="flex h-[70px] w-full items-center justify-center">
        <Spinner data-test="loader" />
      </div>
    );
  }

  if (!playbookResult) {
    return null;
  }

  const title = `${playbookResult.name} ${t("call_context.playbook_summary")}`;

  return (
    <Section data-test="playbook-section">
      <SectionHeader
        addon={
          playbookAdherence && playbookResult.adherenceScore != null ? (
            <PercentBadge
              value={playbookResult.adherenceScore * 100}
              borderless
              tooltip={t("call_context.adherence_score")}
            />
          ) : undefined
        }
      >
        <SectionTitle>{title}</SectionTitle>
      </SectionHeader>

      <div className="flex flex-col rounded-md bg-muted p-4">
        <PlaybookResultsForm playbookResult={playbookResult} />
      </div>
    </Section>
  );
}
